export enum SidebarContent {
    FEATURE_DETAIL_SIDEBAR = 'FEATURE_DETAIL_SIDEBAR',
    CATALOG_LAYERS_SIDEBAR = 'CATALOG_LAYERS_SIDEBAR',
    MEASUREMENT_OVERVIEW_SIDEBAR = 'MEASUREMENT_OVERVIEW_SIDEBAR',
    PRINT_SIDEBAR = 'PRINT_SIDEBAR',
    SHOW_COORDS_SIDEBAR = 'SHOW_COORDS_SIDEBAR',
    SEARCH_SIDEBAR = 'SEARCH_SIDEBAR',
}
